import React from "react"
import './Footer.scss'

export function Footer() {
    return (
        <footer>
            <p className="footer">© 2022 Carpi Coder</p>
        </footer>
    );    
};